export default function yAxis(){
  return {
    autorange: true,
    showgrid: false,
    zeroline: false,
    showticklabels: true,
    ticks: ''
  }
}